/** @jsx jsx */
// External libraries
import { css, jsx } from '@emotion/core';
import { useState } from 'react';
import { useStoreState } from 'easy-peasy';
import { LoadingElement, PayPalLogo } from '@checkout/react-components';

// Internal modules
import { logShowCartOnce } from './utils';
import { CartDropdown } from './CartDropdown';
import { useMountLogging } from '@/lib/reactHooks';
import { LanguageDropdown } from '../Locale';
import { $logger, features, getGlobals } from '@/lib';
import { CartIcon, ChevronIcon } from '../Common/Icons';
import {
  cartButtonWithDropdown,
  chevronStyles,
  chevronStylesCartShown,
} from './styles';
import {
  CartAmount,
  CartButton,
  HeaderContainer,
  LogoContainer,
  StyledHeader,
} from './StyledComponents';

const Header = props => {
  useMountLogging('Header');
  const cartDetails = useStoreState(({ api }) => api.cartDetails);
  const { total = {} } = cartDetails?.amounts || {};
  const [isCartShown, setIsCartShown] = useState(false);
  const handleClick = () => {
    !isCartShown && logShowCartOnce();
    $logger.info(`weasley_cart_dropdown_${isCartShown ? 'hide' : 'show'}`);
    setIsCartShown(!isCartShown);
  };

  // Should load cart dropdown if there's a note or
  // if we have items or cart description
  const shouldLoadCartDropdown = Boolean(
    cartDetails?.noteToBuyer ||
      cartDetails?.items?.length ||
      cartDetails?.description,
  );

  // The language selector is only shown in the header when the billing
  // page is the landing page and there is more than one available language
  const { isBasl } = getGlobals();
  const { enabledLanguages = [] } = features.config;

  return (
    <HeaderContainer isBasl={isBasl}>
      <StyledHeader>
        <LogoContainer>
          <PayPalLogo />
        </LogoContainer>

        {total.currencyFormatSymbolISOCurrency ? (
          <CartButton
            css={[shouldLoadCartDropdown && cartButtonWithDropdown]}
            onClick={shouldLoadCartDropdown ? handleClick : () => {}}
            shouldLoadCartDropdown={shouldLoadCartDropdown}
          >
            <CartIcon height={20} width={22} />
            <CartAmount>{total.currencyFormatSymbolISOCurrency}</CartAmount>
            {shouldLoadCartDropdown && (
              <ChevronIcon
                css={[chevronStyles, isCartShown && chevronStylesCartShown]}
              />
            )}
          </CartButton>
        ) : (
          <LoadingElement
            height="22"
            styleOverrides={css({ zIndex: '1' })}
            viewBoxHeight="22"
            viewBoxWidth="135"
            width="135"
          />
        )}
      </StyledHeader>

      {shouldLoadCartDropdown && (
        <CartDropdown cartDetails={cartDetails} isCartShown={isCartShown} />
      )}

      {isBasl && enabledLanguages.length > 1 && <LanguageDropdown />}
    </HeaderContainer>
  );
};

export { Header };
